import React from "react";
import "./Sidebar.css";
import { Link, NavLink } from "react-router-dom";
import { MdDashboard, MdGroups } from "react-icons/md";
import { FaUserShield, FaBuilding, FaUserTie } from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi";
import { AiOutlineProject } from "react-icons/ai";
import { BsListCheck } from "react-icons/bs";
import { IoBusinessOutline } from "react-icons/io5";

const Sidebar = () => {
  const userRole = localStorage.getItem("role");

  const menuItems = [
    {
      path: "/admindashboard",
      icon: <MdDashboard />,
      label: "Dashboard",
      roles: ["admin"],
    },
    {
      path: "/dashboard",
      icon: <MdDashboard />,
      label: "Dashboard",
      roles: ["manager", "employee", "Team Leader"],
    },
    {
      path: "/clientcompany",
      icon: <FaBuilding />,
      label: "Client Company",
      roles: ["admin"],
    },
    // {
    //   path: "/admin",
    //   icon: <FaUserShield />,
    //   label: "Admin",
    //   roles: ["admin"],
    // },
    {
      path: "/department",
      icon: <IoBusinessOutline />,
      label: "Department",
      roles: ["admin"],
    },
    {
      path: "/project",
      icon: <AiOutlineProject />,
      label: "Project",
      roles: ["admin", "manager"],
    },
    // {
    //   path: "/manager",
    //   icon: <FaUserTie />,
    //   label: "Manager",
    //   roles: ["admin"],
    // },
    {
      path: "/employee",
      icon: <HiUserGroup />,
      label: "Employee",
      roles: ["admin", "manager"],
    },
    {
      path: "/team",
      icon: <MdGroups />,
      label: "Team",
      roles: ["admin", "manager"],
    },
    {
      path: "/subteam",
      icon: <MdGroups />,
      label: "Team Member",
      roles: ["admin"],
    },
    {
      path: "/msubteam",
      icon: <MdGroups />,
      label: "Team Member",
      roles: ["manager"],
    },
    {
      path: "/task",
      icon: <BsListCheck />,
      label: "Task",
      roles: ["manager", "admin","Team Leader"],
    },
    {
      path: "/workflowupdate",
      icon: <IoBusinessOutline />,
      label: "Workflow Update",
      roles: ["employee","Team Leader","manager"],
    },
  ];

  return (
    <div className="sidebar">
      <div className="image">
        <img src="./images/Logo New (1).png" alt="Align Desk" />
      </div>
      <ul className="sidebar-menu">
        {menuItems
          .filter((item) => item.roles.includes(userRole))
          .map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {item.icon}
                {item.label}
              </NavLink>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default Sidebar;
